import React from 'react';

import { Tooltip, Button as MUIButton, type ButtonProps as MUIButtonProps } from '@mui/material';

type ButtonProps = {
  title: string;
  ariaDescribedBy: string | undefined;
  size: MUIButtonProps['size'];
  variant: MUIButtonProps['variant'];
  color: MUIButtonProps['color'];
  text: string;
  startIcon?: React.ReactNode;
  onClick?: ((event: React.MouseEvent<HTMLButtonElement>) => void) | (() => void);
  show?: boolean;
  disabled?: boolean;
  popover: React.ReactElement | null | undefined;
  type?: 'button' | 'submit' | 'reset';
  form?: string;
};

export const Button = ({
  title,
  ariaDescribedBy,
  size,
  variant,
  color,
  text,
  startIcon,
  onClick,
  show = true,
  disabled = false,
  popover,
  type,
  form,
}: ButtonProps) => {
  if (!show) return null;

  return (
    <>
      <Tooltip title={title} arrow placement="top">
        <span>
          <MUIButton
            aria-describedby={ariaDescribedBy}
            size={size}
            variant={variant}
            color={color}
            startIcon={startIcon}
            onClick={onClick}
            disabled={disabled}
            type={type}
            form={form}
            sx={{ whiteSpace: 'nowrap' }}
          >
            {text}
          </MUIButton>
        </span>
      </Tooltip>
      {popover}
    </>
  );
};
